"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Select.scss");
var key_press_1 = require("../../../utils/key-press");
var UserAgent_1 = require("../../../helpers/Functions/UserAgent");
var Join_1 = require("../../../helpers/Functions/Join");
var Select = React.forwardRef(function (props, ref) {
    var className = props.className, _a = props.defaultValue, defaultValue = _a === void 0 ? -1 : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.errorMsg, errorMsg = _c === void 0 ? "" : _c, _d = props.errorState, errorState = _d === void 0 ? false : _d, _e = props.label, label = _e === void 0 ? "Select an Option" : _e, _f = props.multiline, multiline = _f === void 0 ? false : _f, _g = props.native, native = _g === void 0 ? UserAgent_1.isAndroid() || UserAgent_1.isIos() : _g, _h = props.nativePlaceHolder, nativePlaceHolder = _h === void 0 ? false : _h, onChange = props.onChange, onBlur = props.onBlur, onKeyPress = props.onKeyPress, onError = props.onError, onClick = props.onClick, onFocus = props.onFocus, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, onHover = props.onHover, options = props.options, placeholder = props.placeholder, style = props.style, testId = props.testId, _j = props.useOnlyErrorState, useOnlyErrorState = _j === void 0 ? false : _j, _k = props.resetOption, resetOption = _k === void 0 ? false : _k;
    var buttonRef = React.createRef();
    var containerRef = React.createRef();
    var dropdownRef = React.createRef();
    var refOptions = __spread(Array(options.length)).map(function (_, i) { return i; });
    var group;
    var setSearchResults = function () {
        var obj = [];
        options.forEach(function (option, i) {
            obj.push({ index: i, value: option.value });
        });
        return obj;
    };
    var _l = __read(React.useState({
        altPressed: false,
        clicked: false,
        current: 0,
        error: false,
        nativeArrowOpen: false,
        searchResults: setSearchResults(),
        selected: defaultValue,
        show: false,
        showFocus: true,
    }), 2), state = _l[0], setState = _l[1];
    var firstUpdate = React.useRef(true);
    var _m = __read(React.useState(false), 2), refresh = _m[0], setRefresh = _m[1];
    var _o = __read(React.useState(null), 2), timer = _o[0], setTimer = _o[1];
    var altPressed = state.altPressed, clicked = state.clicked, current = state.current, error = state.error, searchResults = state.searchResults, selected = state.selected, show = state.show, showFocus = state.showFocus;
    var setFocus = function (value) {
        if (value !== showFocus) {
            setState(__assign(__assign({}, state), { showFocus: value }));
        }
    };
    var setFocusFalse = function () {
        setFocus(false);
    };
    var setFocusTrue = function () {
        setFocus(true);
    };
    React.useEffect(function () {
        if (!native) {
            if (process.browser) {
                document.addEventListener("mousedown", setFocusFalse, false);
                document.addEventListener("keydown", setFocusTrue, false);
            }
            if (show) {
                if (process.browser) {
                    document.addEventListener("mouseup", handleMouseUp, false);
                }
                refOptions[current].focus();
                if (!UserAgent_1.isIE() && dropdownRef.current !== null) {
                    dropdownRef.current.scrollTo(0, refOptions[current].offsetTop);
                }
                if (current === 0) {
                    setTimeout(function () {
                        if (dropdownRef.current !== null) {
                            dropdownRef.current.scrollTop = 0;
                        }
                    }, 0);
                }
            }
            if (refresh) {
                setRefresh(false);
                setTimer(null);
                setState(__assign(__assign({}, state), { searchResults: setSearchResults() }));
            }
            return function cleanup() {
                if (process.browser) {
                    document.removeEventListener("mouseup", handleMouseUp, false);
                    if (!native) {
                        document.removeEventListener("mousedown", setFocusFalse, false);
                        document.removeEventListener("keydown", setFocusTrue, false);
                    }
                }
            };
        }
    });
    React.useEffect(function () {
        onChangeEvent();
    }, [state.selected]);
    React.useEffect(function () {
        setState(__assign(__assign({}, state), { selected: defaultValue }));
    }, [defaultValue]);
    React.useEffect(function () {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        setState(__assign(__assign({}, state), { selected: -1, current: 0 }));
    }, [resetOption]);
    /* Event Handlers */
    var onChangeEvent = function () {
        if (onChange) {
            onChange(state);
        }
    };
    var onBlurEvent = function () {
        if (onBlur) {
            onBlur(state);
        }
    };
    var onErrorEvent = function () {
        if (onError) {
            onError(state);
        }
    };
    var onClickEvent = function () {
        if (onClick) {
            onClick(state);
        }
    };
    var onFocusEvent = function () {
        if (onFocus) {
            onFocus(state);
        }
    };
    var onMouseDownEvent = function () {
        if (onMouseDown) {
            onMouseDown(state);
        }
    };
    var onMouseUpEvent = function () {
        if (onMouseUp) {
            onMouseUp(state);
        }
    };
    var onHoverEvent = function () {
        if (onHover) {
            onHover(state);
        }
    };
    var onKeyPressEvent = function (k) {
        if (onKeyPress) {
            onKeyPress(k, state);
        }
    };
    var getId = function () {
        var temp = label
            .replace(/ /g, "-")
            .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")
            .toLowerCase();
        while (process.browser && document.getElementById(temp)) {
            temp = temp.concat(Math.floor(Math.random() * 100 + 1).toString());
        }
        return temp;
    };
    var showDropdown = function () {
        setState(__assign(__assign({}, state), { clicked: true, nativeArrowOpen: true, show: !state.show }));
        onClickEvent();
    };
    var hideDropdown = function () {
        if (!native && buttonRef.current !== null) {
            buttonRef.current.focus();
        }
        setState(__assign(__assign({}, state), { current: selected === -1 ? 0 : selected, searchResults: setSearchResults(), show: false }));
        clearTimeout(timer);
    };
    var handleSelection = function (i) {
        if (!native && buttonRef.current !== null) {
            buttonRef.current.focus();
        }
        setState(__assign(__assign({}, state), { current: i, error: false, nativeArrowOpen: false, selected: i, show: native }));
    };
    var handleNativeSelection = function (e) {
        var temp = parseInt(e.target.value, 10);
        handleSelection(temp);
    };
    var handleOnBlur = function () {
        onBlurEvent();
        if ((!show && clicked && selected === -1) || (selected === -1 && clicked && native)) {
            onErrorEvent();
            setState(__assign(__assign({}, state), { error: true, nativeArrowOpen: false }));
        }
        else {
            setState(__assign(__assign({}, state), { nativeArrowOpen: false }));
        }
    };
    var searchOptions = function (e) {
        clearTimeout(timer);
        var letterChar = key_press_1.isLetterChar(e);
        var specialChar = key_press_1.isSpecialChar(e, altPressed);
        var digitChar = key_press_1.isDigitChar(e);
        var keyChar = letterChar
            ? letterChar
            : specialChar
                ? specialChar
                : digitChar
                    ? digitChar
                    : undefined;
        if (!keyChar) {
            return;
        }
        var temp = [];
        searchResults.forEach(function (item) {
            var value = item.value;
            var optionChar = value.charAt(0).toUpperCase();
            if (optionChar.localeCompare(keyChar) === 0) {
                item.value = value.substring(1);
                temp.push(item);
            }
        });
        temp.forEach(function (singleItem, indexInner) {
            temp[indexInner]["next"] = temp[indexInner + 1]
                ? temp[indexInner + 1].index
                : temp[0].index;
        });
        var handleNextSelect = function (tempObj, currentPos) {
            var tempData = 0;
            if (tempObj.length) {
                tempObj.forEach(function (item) {
                    if (item.index === current) {
                        tempData = item;
                    }
                });
                tempData = searchResults[tempData.next] ? searchResults[tempData.next] : tempObj[0];
            }
            return tempData.index;
        };
        setState(__assign(__assign({}, state), { current: temp.length === 0 ? current : handleNextSelect(temp, current), searchResults: temp }));
        setTimer(setTimeout(function () { return setRefresh(true); }, 1000));
    };
    var handleMouseUp = function (e) {
        if (containerRef.current !== null && containerRef.current.contains(e.target)) {
            return;
        }
        else {
            hideDropdown();
        }
    };
    var keyUpDropDown = function (e) {
        if (key_press_1.KeyPress.altIsPressed(e) || key_press_1.KeyPress.shiftIsPressed(e)) {
            setState(__assign(__assign({}, state), { altPressed: false }));
        }
    };
    var keyPressedDropDown = function (e) {
        onKeyPressEvent(e);
        if (key_press_1.KeyPress.tabIsPressed(e)) {
            hideDropdown();
            return;
        }
        e.preventDefault();
        if (key_press_1.KeyPress.downArrowIsPressed(e)) {
            if (current < options.length - 1) {
                setState(__assign(__assign({}, state), { current: current + 1 }));
            }
            else {
                setState(__assign(__assign({}, state), { current: 0 }));
            }
        }
        else if (key_press_1.KeyPress.upArrowIsPressed(e)) {
            if (current > 0) {
                setState(__assign(__assign({}, state), { current: current - 1 }));
            }
            else {
                setState(__assign(__assign({}, state), { current: options.length - 1 }));
            }
        }
        else if (key_press_1.KeyPress.homeIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: 0 }));
        }
        else if (key_press_1.KeyPress.endIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: options.length - 1 }));
        }
        else if (key_press_1.KeyPress.pageUpIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current - 3 >= 0 ? current - 3 : 0 }));
        }
        else if (key_press_1.KeyPress.pageDownIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current + 3 < options.length ? current + 3 : options.length - 1 }));
        }
        else if (key_press_1.KeyPress.escIsPressed(e)) {
            hideDropdown();
        }
        else if (key_press_1.KeyPress.enterIsPressed(e)) {
            handleSelection(current);
        }
        else if (key_press_1.KeyPress.altIsPressed(e) || key_press_1.KeyPress.shiftIsPressed(e)) {
            if (!altPressed) {
                setState(__assign(__assign({}, state), { altPressed: true }));
            }
        }
        else {
            searchOptions(e);
        }
    };
    var labelId = getId();
    var hasGroup = options.filter(function (option) { return option.group !== undefined; }).length > 0;
    return (React.createElement("div", { className: Join_1.join([
            className,
            (error || useOnlyErrorState) && errorState ? "error" : "",
            show ? "active" : "",
        ]), "data-testid": testId, ref: ref, style: style },
        React.createElement("label", { className: Join_1.join([
                "formfield-label",
                styles.label,
                disabled ? "disabled" : "",
                (error || useOnlyErrorState) && errorState ? "error" : "",
            ]), htmlFor: labelId, id: "msg-" + labelId }, label),
        React.createElement("div", { className: Join_1.join([
                "selectWrap",
                (error || useOnlyErrorState) && errorState ? "error" : "",
            ]), ref: containerRef }, native ? (React.createElement(React.Fragment, null,
            React.createElement("select", { "aria-invalid": (error || useOnlyErrorState) && errorState, className: Join_1.join([
                    "awd-select",
                    "dropdown-button",
                    "color-ui-black",
                    "text-left",
                    styles.dropdownButton,
                    styles.awdSelect,
                    !multiline
                        ? Join_1.join([styles.dropdownButtonMultiline, "overflow-hidden"])
                        : "",
                    selected === -1
                        ? styles.dropdownButtonNotSelected
                        : styles.dropdownButtonSelected,
                ]), "aria-expanded": show, disabled: disabled, id: labelId, onBlur: handleOnBlur, onChange: handleNativeSelection, onClick: showDropdown, onFocus: onFocusEvent, onMouseDown: onMouseDownEvent, onMouseOver: onHoverEvent, onMouseUp: onMouseUpEvent, value: selected === -1 ? -1 : selected },
                !nativePlaceHolder ? (Boolean(placeholder) ? (React.createElement("option", { dangerouslySetInnerHTML: {
                        __html: placeholder ? placeholder : "",
                    }, disabled: true, value: -1 })) : (React.createElement("option", { disabled: true, value: -1 }, "Select"))) : (""),
                options.map(function (option, i) {
                    if ("group" in option &&
                        (i === 0 || options[i].group !== options[i - 1].group)) {
                        group = [
                            React.createElement("option", { "aria-selected": selected === i, key: i, value: i }, option.value),
                        ];
                    }
                    else {
                        if ("group" in option) {
                            group.push(React.createElement("option", { "aria-selected": selected === i, dangerouslySetInnerHTML: {
                                    __html: option.value,
                                }, key: i, value: i }));
                            if (i === options.length - 1 ||
                                options[i].group !== options[i + 1].group) {
                                return (React.createElement("optgroup", { key: Join_1.join(["Group-Label", i.toString()]), label: option.group }, group.map(function (innerOption, key) {
                                    return innerOption;
                                })));
                            }
                        }
                        else {
                            return (React.createElement("option", { dangerouslySetInnerHTML: {
                                    __html: option.value,
                                }, key: i, value: i }));
                        }
                    }
                })),
            React.createElement("span", { className: Join_1.join([
                    "select-skin",
                    styles.selectSkin,
                    show ? styles.selectSkinOpen : "",
                ]) }))) : (React.createElement(React.Fragment, null,
            React.createElement("button", { "aria-describedby": "msg-" + labelId, "aria-expanded": show, "aria-invalid": (error || useOnlyErrorState) && errorState, "aria-label": options[selected] && options[selected].value
                    ? options[selected].value + "( is selected)"
                    : label, className: Join_1.join([
                    "dropdown-button",
                    styles.dropdownButton,
                    "text-left",
                    !multiline
                        ? Join_1.join([styles.dropdownButtonMultiline, "overflow-hidden"])
                        : "",
                    selected === -1
                        ? styles.dropdownButtonNotSelected
                        : styles.dropdownButtonSelected,
                    showFocus ? styles.dropdownButtonFocus : "",
                ]), dangerouslySetInnerHTML: {
                    __html: Boolean(placeholder)
                        ? selected === -1
                            ? placeholder
                                ? placeholder
                                : "Select"
                            : options[selected].value
                        : selected === -1
                            ? "Select"
                            : options[selected] ? options[selected].value : "",
                }, disabled: disabled, id: labelId, "aria-controls": labelId + "-select", role: "combobox", ref: buttonRef, onBlur: handleOnBlur, onClick: show ? hideDropdown : showDropdown, onFocus: onFocusEvent, onMouseDown: onMouseDownEvent, onMouseOver: onHoverEvent, onMouseUp: onMouseUpEvent }),
            React.createElement("div", { className: Join_1.join([
                    "optionWrapper",
                    "overflow-y-scroll",
                    styles.optionWrapper,
                    show ? Join_1.join([styles.optionWrapperOpen, "open"]) : "",
                ]), onKeyDown: keyPressedDropDown, onKeyUp: keyUpDropDown, ref: dropdownRef, id: labelId + "-select" }, show &&
                options.map(function (option, i) {
                    if ("group" in option &&
                        (i === 0 || options[i].group !== options[i - 1].group)) {
                        return [
                            React.createElement("label", { className: Join_1.join([
                                    "formfield-label",
                                    "color-ui-dark-gray",
                                    styles.group,
                                ]), key: Join_1.join(["Group-Label", i.toString()]) }, option.group),
                            React.createElement("button", { "aria-label": selected === i
                                    ? "Group " +
                                        option.group +
                                        " " +
                                        option.value +
                                        "( is selected)"
                                    : "Group " +
                                        option.group +
                                        " " +
                                        option.value, "aria-posinset": i + 1, "aria-selected": selected === i, "aria-setsize": options.length, ref: function (node) {
                                    refOptions[i] = node;
                                }, className: Join_1.join([
                                    "optgroup-wrapper",
                                    "option-list-item",
                                    "text-left",
                                    hasGroup ? styles.optionListItemPad : "",
                                    styles.optionListItem,
                                ]), dangerouslySetInnerHTML: {
                                    __html: option.value,
                                }, key: i, name: option.value, onClick: handleSelection.bind(null, i), role: "option", type: "button" }),
                        ];
                    }
                    else {
                        return (React.createElement("button", { "aria-label": "group" in option
                                ? selected === i
                                    ? "Group " +
                                        option.group +
                                        " " +
                                        option.value +
                                        "( is selected)"
                                    : "Group " +
                                        option.group +
                                        " " +
                                        option.value
                                : selected === i
                                    ? option.value + "( is selected)"
                                    : option.value, "aria-posinset": i + 1, "aria-selected": selected === i, "aria-setsize": options.length, className: Join_1.join([
                                "optgroup-wrapper",
                                "option-list-item",
                                "text-left",
                                styles.optionListItem,
                                hasGroup ? styles.optionListItemPad : "",
                            ]), dangerouslySetInnerHTML: {
                                __html: option.value,
                            }, key: i, onClick: handleSelection.bind(null, i), ref: function (node) {
                                refOptions[i] = node;
                            }, role: "option" }));
                    }
                }))))),
        errorState && (error || useOnlyErrorState) && errorMsg && (React.createElement("span", { "aria-live": "polite", className: Join_1.join(["formfield-msg", styles.requiredError]), id: labelId.concat("-error") }, errorMsg))));
});
exports.default = Select;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Select/Select.js
// module id = 671
// module chunks = 8